// extracted by mini-css-extract-plugin
export default {"slidecontainer":"range_slidecontainer__q11X8","slider":"range_slider__ayt8D"};